import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M9 12l4 -4v8l-4 -4","key":"svg-0"}],["path",{"d":"M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18","key":"svg-1"}]]

const IconCircleCaretLeft = createReactComponent('outline', 'circle-caret-left', 'CircleCaretLeft', __iconNode);

export default IconCircleCaretLeft;